var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated"},[(_vm.analyte_result_collection)?_c('AnalyteResultServerTable',{attrs:{"collection":_vm.analyte_result_collection,"show_columns":[
      'analyte',
      'result'
    ]}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }